import { useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

import css from './GenericErrorTemplate.module.css';
import { TeamsystemAppBar } from '../TeamsystemAppBar';

type GenericErrorTemplateType = React.FC<{
    image: {
        src: string;
        alt: string;
        style?: React.CSSProperties;
    }
    title: string;
    description: string | React.ReactNode;
    hideActions?: boolean;
    actions?: React.ReactNode;
    hideAppBar?: boolean;
}>;

export const GenericErrorTemplate: GenericErrorTemplateType = (props) => {

    const {
        title,
        description,
        image,
        hideActions = true,
        actions,
        hideAppBar
    } = props;

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    return (
        <Box className={css.genericErrorContainer}>
            <Box className={css.genericErrorWrapper}>
                {!hideAppBar && (
                    <TeamsystemAppBar hideActions={hideActions} />
                )}
                <Box className={css.genericErrorContent}>
                    <Box className={css.genericErrorTemplate}>
                        {isDesktop && (
                            <Box>
                                <img rel="preload" src={image.src} alt={image.alt} style={{ ...image.style, aspectRatio: 'auto' }} />
                            </Box>
                        )}
                        <Box className={css.typographyContainer}>
                            <Box className={css.typographyTitle}>{title}</Box>
                            <Box className={css.typographyDescription}>{description}</Box>
                            {actions && (
                                <Box className={css.actionsContainer}>
                                    {actions}
                                </Box>
                            )}
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};
